// Example about data for demo mode
import React from 'react';
import { 
  Code,
  Star,
  Bug,
  Lightbulb,
  MessageCircle,
  Languages,
  Stethoscope,
  FileText
} from 'lucide-react';

export const exampleFeatureInspirations = [
  {
    feature: "Zippy Food Tracker & Correlation Analysis",
    inspiringPerson: "Aunt Maggie",
    relationship: "Eric Henderson's Aunt",
    background: "30+ years working in hospital blood banks, Type 2 diabetes patient",
    challenge: "Wanted to easily track food consumption and correlate it with FreeStyle Libre glucose readings to identify triggering events with statistical proof",
    solution: "Built an AI-powered correlation analysis system that tracks macronutrients, supplements, exercise context, and glucose response patterns",
    impact: "Aunt Maggie can now see clear statistical relationships between her food choices and glucose spikes, helping her make informed dietary decisions",
    image: "👩‍⚕️"
  }
];

export const exampleContributorCategories = [
  {
    category: 'Code Contribution',
    icon: <Code className="h-5 w-5" />,
    color: 'bg-blue-100 text-blue-700 border-blue-200',
    description: 'Bug fixes, feature development, performance improvements'
  },
  {
    category: 'Design & UX',
    icon: <Star className="h-5 w-5" />,
    color: 'bg-purple-100 text-purple-700 border-purple-200',
    description: 'UI improvements, UX research, accessibility enhancements'
  },
  {
    category: 'Bug Hunter',
    icon: <Bug className="h-5 w-5" />,
    color: 'bg-red-100 text-red-700 border-red-200',
    description: 'Identified and reported bugs or technical issues'
  },
  {
    category: 'Feature Ideas',
    icon: <Lightbulb className="h-5 w-5" />,
    color: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    description: 'Suggested new features and platform improvements'
  },
  {
    category: 'UI Quality Assurance',
    icon: <MessageCircle className="h-5 w-5" />,
    color: 'bg-orange-100 text-orange-700 border-orange-200',
    description: 'Reported usability issues and interface problems'
  },
  {
    category: 'Content & Grammar',
    icon: <FileText className="h-5 w-5" />,
    color: 'bg-indigo-100 text-indigo-700 border-indigo-200',
    description: 'Grammar corrections, content improvements, proofreading'
  },
  {
    category: 'Translation Services',
    icon: <Languages className="h-5 w-5" />,
    color: 'bg-teal-100 text-teal-700 border-teal-200',
    description: 'Language translations and localization support'
  },
  {
    category: 'Medical Review',
    icon: <Stethoscope className="h-5 w-5" />,
    color: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    description: 'Medical content validation by verified healthcare professionals'
  }
]; 